import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import { ThemeProvider } from '@h2/components/themes/provider'
import { setUser } from '@h2/common/actions/setUser'

import { GlobalsProvider } from './globals'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
})
const Providers = ({ children }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (dynamicValues.userProfile) {
      dispatch(setUser(dynamicValues.userProfile))
    }
  }, [dispatch])

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <GlobalsProvider>{children}</GlobalsProvider>
      </ThemeProvider>
      {REACT_QUERY_DEVTOOLS && <ReactQueryDevtools />}
    </QueryClientProvider>
  )
}

export { Providers }
